import { render, staticRenderFns } from "./mealRecord.vue?vue&type=template&id=00629a9b&scoped=true"
import script from "./mealRecord.vue?vue&type=script&lang=js"
export * from "./mealRecord.vue?vue&type=script&lang=js"
import style0 from "./mealRecord.vue?vue&type=style&index=0&id=00629a9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00629a9b",
  null
  
)

export default component.exports